module.exports = __webpack_public_path__ + "img/bedland_slide_1.4f8191e7.jpg";